<script>
import { Doughnut } from "vue-chartjs";

export default {
  name: "ChartDoughnut",
  extends: Doughnut,
  props: {
    data: { type: Object, required: true },
    options: { type: Object, default: null },
    styles: {
      type: Object,
      default: () => ({ position: "relative", height: "100%", width: "100%" }),
    },
  },
  watch: {
    data() {
      this.render();
    },
    options() {
      this.render();
    },
  },
  mounted() {
    this.render();
  },
  methods: {
    render() {
      this.renderChart(
        this.data,
        this.options || {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: "bottom" },
          cutoutPercentage: 65,
        }
      );
    },
  },
};
</script>
